export const DEFAULT_ROUTES = {
  pos: '/pos/home',
  merchant: '/merchant',
  user: '/',
  unauthenticated: '/auth/login',
};
